import React, { useEffect, useState, useRef } from "react";
import cls from "classnames";

import styles from "./index.scss";

interface LoadingProps extends React.HTMLAttributes<HTMLDivElement> {
  visible: boolean;
  mask?: boolean;
  delay?: number;
  inline?: boolean;
}

export default function Loading(props: LoadingProps): JSX.Element | null {
  const [visible, setVisible] = useState(false);
  const { mask, delay = 0, inline, visible: propsVisible, className, ...rest } = props;
  const staticRef = useRef({ timer: 0 });

  const setLoadingTimer = (): void => {
    clearTimeout(staticRef.current.timer);
    staticRef.current.timer = window.setTimeout(() => {
      setVisible(propsVisible);
    }, delay);
  };

  useEffect(() => {
    if (propsVisible !== visible) {
      setLoadingTimer();
    }
    return (): void => {
      staticRef.current.timer && clearTimeout(staticRef.current.timer);
    };
  }, [propsVisible, delay]);
  return visible ? (
    <div
      className={cls(styles.al_loading, className, {
        [styles.inline]: inline,
        [styles.mask]: mask,
      })}
      {...rest}
    >
      <div className={styles.loading}>
        <span className={styles.loading_item}></span>
        <span className={styles.loading_item}></span>
        <span className={styles.loading_item}></span>
        <span className={styles.loading_item}></span>
      </div>
    </div>
  ) : null;
}
